import React from "react";
import { getIcons } from "../../Constant/Constant";
import { LiaFileUploadSolid } from "react-icons/lia";

const BulkUploadModal = ({
  isOpen,
  onClose,
  modalHeading,
  selectedFile,
  onFileChange,
  onUpload,
  onDownloadTemplate,
  currentCount,
  maxCount
}) => {
  const icon = getIcons();
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="bulk-upload-title"
    >
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-xl p-6">
        
        {/* Modal Header */}
             {/* Header */}
             <div className="flex bg-slate-100 p-2 rounded-md justify-between items-center mb-6">
          <h2
            id="bulk-upload-title"
            className="text-lg font-medium text-customGreen"
          >
             Bulk Upload for {modalHeading}
          </h2>
          <button
            onClick={onClose}
            className="text-red-600 bg-white px-2 focus:outline-none  rounded-full p-1"
            aria-label="Close modal"
          >
            <svg
              className="w-5 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
 

        {/* File Upload Section */}
        <div className="space-y-4 mb-6">
          <div className="flex justify-between items-center">
            <label htmlFor="file-upload" className="text-lg font-medium text-gray-700">
              Attach File
            </label>
            <button
              onClick={onDownloadTemplate}
              className="flex items-center gap-2 text-sm text-customGreen hover:underline"
            >
              <img src={icon.downloadIcon} alt="Download Template" className="w-4 h-4" />
              Download Template
            </button>
          </div>

          <label htmlFor="file-upload" className="block cursor-pointer">
            <div className="relative border border-gray-300 hover:border-gray-400 transition rounded-lg px-4 py-3 text-gray-600 bg-gray-50">
              <span className="flex items-center gap-2">
       <LiaFileUploadSolid className="w-6 h-6 text-customGreen" />
                <span>{selectedFile ? selectedFile.name : "Click to select a file (.xlsx)"}</span>
              </span>
              <input
                id="file-upload"
                type="file"
                accept=".xlsx,.csv"
                onChange={onFileChange}
                className="absolute inset-0 opacity-0 cursor-pointer"
              />
            </div>
          </label>
        </div>

        {/* Footer Actions */}
        <div className="flex justify-between items-center">
          <span className="text-sm text-gray-500">
            {currentCount}/{maxCount} {modalHeading?.toLowerCase()} used
          </span>
          <button
            onClick={onUpload}
            disabled={!selectedFile}
            className={`w-32 text-center py-2 rounded-md font-medium transition-colors duration-200 ${
              selectedFile
                ? "bg-customGreen text-white hover:bg-green-600"
                : "bg-gray-300 text-gray-500 cursor-not-allowed"
            }`}
          >
            Upload
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkUploadModal;
